/**
 * /minhas-pendencias: a agenda nova para quem ela está liberada (chave
 * AGENDA_V2, temporária até a Fase 8, quando a tela antiga sai) e a tela
 * antiga para os demais. Sem resposta do servidor, fica a tela antiga: ela
 * continua funcionando, e a pessoa não vê uma tela pela metade.
 */

import { Suspense, lazy, useEffect, useState } from "react";

import { PageLoader } from "../../components/LoadingMarcenaria";
import { useAuth } from "../../context/AuthContext";
import { lerEstado } from "../../services/agenda";
import MinhasPendencias from "../MinhasPendencias";

const AgendaApp = lazy(() => import("./AgendaApp"));

export default function RotaDaAgenda() {
  const { request } = useAuth();
  const [liberada, setLiberada] = useState(null);

  useEffect(() => {
    let vivo = true;
    lerEstado(request)
      .then((resposta) => { if (vivo) setLiberada(Boolean(resposta?.liberada)); })
      .catch(() => { if (vivo) setLiberada(false); });
    return () => { vivo = false; };
  }, [request]);

  if (liberada === null) return <PageLoader message="Abrindo a agenda…" />;
  if (!liberada) return <MinhasPendencias />;
  return (
    <Suspense fallback={<PageLoader message="Abrindo a agenda…" />}>
      <AgendaApp />
    </Suspense>
  );
}
